/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface WorkOtherTitleDTO
 */
export interface WorkOtherTitleDTO  {
    /**
     * 
     * @type {number}
     * @memberof WorkOtherTitleDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkOtherTitleDTO
     */
    language?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOtherTitleDTO
     */
    otherTitle?: string;
}

/**
 * Check if a given object implements the WorkOtherTitleDTO interface.
 */
export function instanceOfWorkOtherTitleDTO(value: object): value is WorkOtherTitleDTO {
    return true;
}

export function WorkOtherTitleDTOFromJSON(json: any): WorkOtherTitleDTO {
    return WorkOtherTitleDTOFromJSONTyped(json, false);
}

export function WorkOtherTitleDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOtherTitleDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'language': json['language'] == null ? undefined : json['language'],
                  'otherTitle': json['otherTitle'] == null ? undefined : json['otherTitle'],
    };
}

export function WorkOtherTitleDTOToJSON(json: any): WorkOtherTitleDTO {
    return WorkOtherTitleDTOToJSONTyped(json, false);
}

export function WorkOtherTitleDTOToJSONTyped(value?: WorkOtherTitleDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'language': value['language'],
        'otherTitle': value['otherTitle'],
    };
}


